/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    LoaFieldRule,
    LoaFieldRuleFromJSON,
    LoaFieldRuleFromJSONTyped,
    LoaFieldRuleToJSON,
} from './LoaFieldRule';

/**
 * 
 * @export
 * @interface LoaMetadata
 */
export interface LoaMetadata {
    /**
     * 
     * @type {string}
     * @memberof LoaMetadata
     */
    id?: string;
    /**
     * 
     * @type {number}
     * @memberof LoaMetadata
     */
    defaultLevelOfAssurance?: number;
    /**
     * 
     * @type {Array<LoaFieldRule>}
     * @memberof LoaMetadata
     */
    loaFieldRules?: Array<LoaFieldRule>;
    /**
     * 
     * @type {string}
     * @memberof LoaMetadata
     */
    certificateThumbPrint?: string;
}

export function LoaMetadataFromJSON(json: any): LoaMetadata {
    return LoaMetadataFromJSONTyped(json, false);
}

export function LoaMetadataFromJSONTyped(json: any, ignoreDiscriminator: boolean): LoaMetadata {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'defaultLevelOfAssurance': !exists(json, 'defaultLevelOfAssurance') ? undefined : json['defaultLevelOfAssurance'],
        'loaFieldRules': !exists(json, 'loaFieldRules') ? undefined : ((json['loaFieldRules'] as Array<any>).map(LoaFieldRuleFromJSON)),
        'certificateThumbPrint': !exists(json, 'certificateThumbPrint') ? undefined : json['certificateThumbPrint'],
    };
}

export function LoaMetadataToJSON(value?: LoaMetadata | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'defaultLevelOfAssurance': value.defaultLevelOfAssurance,
        'loaFieldRules': value.loaFieldRules === undefined ? undefined : ((value.loaFieldRules as Array<any>).map(LoaFieldRuleToJSON)),
        'certificateThumbPrint': value.certificateThumbPrint,
    };
}

